<template>
  <v-card>
    <v-card-title class="ml-2">
      {{$i18n.useAddBranchModal.ADD_BRANCH}}
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text class="pt-2">
      <v-form :ref="CREATE_BRANCH_FORM_KEY">
        <v-container pa-0 grid-list-lg>
          <v-row>
            <v-col>
              <fp-chip-radio
                  v-model="branch.branchType"
                  :items="branchTypes"
                  item-key="type"
                  item-name="name_pl"/>
              <v-layout>
                <AddressForm
                  v-model="branch.address"
                  :required="true"
                  :longForm="false"
                />
              </v-layout>
              <v-layout>
                <edit-user-business-hours v-model="branchHours"/>
              </v-layout>
              <v-layout v-if="!isCertifiedBranchOrRODomain">
                <fp-input v-model="branch.businessProfileUrl" :label="$i18n.useAddBranchModal.BUSINESS_CARD_URL" branch-business-card xs12 />
              </v-layout>
              <v-layout>
                <v-col cols="6" class="pl-2">
                  <fp-checkbox
                    :label="$i18n.useAddBranchModal.ACTIVE"
                    v-model="branch.active"
                  />
                </v-col>
              </v-layout>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-card-text>
    <v-divider/>
    <v-card-actions class="pl-6">
      <fp-btn
        primary
        :click="()=>createBranch()"
      >{{ $i18n.useAddBranchModal.ADD_BRANCH }}</fp-btn>
      <v-spacer/>
    </v-card-actions>
  </v-card>
</template>
<script lang="ts">
import {Component} from 'vue-property-decorator';
import {VueModalComponent} from 'fp-components';
import {BranchTypeModel, CreateBranchModel} from '@/modules/branches/models/Branch';
import BranchApi from '@/modules/branches/services/BranchApi';
import AddressForm from '@/components/address/AddressForm.vue';
import BranchTypes from '@/modules/branches/services/BranchTypes';
import EditUserBusinessHours from '@/modules/user/editUser/EditUserBusinessHours.vue';
import {userBusinessHours, UserBusinessHoursElement} from '@/models/UserBusinessHoursElement';
import FpChipRadio from '@/components/inputs/FpChipRadio.vue';
import {BranchType} from '@/modules/branches/enums/BranchType';
import EnvironmentService from '@/env/EnvironmentService';

@Component({
  components: {FpChipRadio, AddressForm, EditUserBusinessHours,},
})
export default class AddBranchModal extends VueModalComponent<any> {
  public readonly CREATE_BRANCH_FORM_KEY: string = 'CREATE_BRANCH_FORM_KEY';
  public branch: CreateBranchModel = new CreateBranchModel();
  public branchHours: UserBusinessHoursElement[] = userBusinessHours;
  public branchTypes: BranchTypeModel[] = BranchTypes;

  get isCertifiedBranchOrRODomain() {
    return this.branch.branchType === BranchType.CERTIFIED || EnvironmentService.Environment.isAppDomain().NESTO_RO;
  }

  async createBranch() {
    if (this.$validate(this.CREATE_BRANCH_FORM_KEY)) {
      try {
        const branchAddress = this.branch.address;
        this.branch.name = `${branchAddress.city} - ${branchAddress.street} ${branchAddress.streetNum}`;
        if (this.isCertifiedBranchOrRODomain) {
          this.branch.businessProfileUrl = null;
        }
        const response = await BranchApi.createBranch(this.branch);
        if (response) {
          await this.setBranchHours(response.id);
        }
        this.closeModal(response);
      } catch (e) {
        this.errorHandler(e);
      }
    }
  }

  async setBranchHours(id: number) {
    try {
      if (this.branchHours) {
        const response = await BranchApi.updateBranchHours(id, this.branchHours);
      }
    } catch (e) {
      this.errorHandler(e);
    }
  }
}
</script>
<style scoped lang="scss">
</style>
